import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import SVG from "images/Trash.svg?react";

import "./BTIconTrash.less";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

interface IBTIconTrashProps extends IBTIconProps {
    isDangerous?: boolean;
}

export const BTIconTrash: FunctionComponent<IBTIconTrashProps> = (baseProps) => {
    const { isDangerous, ...iconProps } = baseProps;
    const [props] = useBaseIcon(iconProps);

    return (
        // eslint-disable-next-line react/forbid-elements
        <Icon
            {...props}
            component={SVG}
            className={cn("BTIconTrash", props.className, { isDangerous })}
        />
    );
};
